import { createSelector } from "reselect";
import getDomain from "../base_getters/get_domain";

const getOrganizationsByFirebaseId = createSelector([
  getDomain
], (domain) => domain.organizations.byFirebaseId);

export default getOrganizationsByFirebaseId;
